/**
 * Opt in locally with VITE_DMP_CHAT_MOCK=true.
 * import.meta.env.MODE keeps mock mode unavailable in production builds.
 */
export const DMP_CHAT_MOCK_ENABLED: boolean =
  import.meta.env.MODE === 'development' && import.meta.env.VITE_DMP_CHAT_MOCK === 'true'
